import { Timeline, Popover, Tag } from 'antd'

import {
    FileSearchOutlined,
    GlobalOutlined,
    AppleOutlined,
    YoutubeOutlined,
    AndroidOutlined
} from '@ant-design/icons'


import hhi1 from '../images/portfolio/hhi1.jpg'
import hhi2 from '../images/portfolio/hhi2.jpg'
import hhi3 from '../images/portfolio/hhi3.jpg'
import line from '../images/portfolio/line.jpg'
import sc2555 from '../images/portfolio/sc2555.jpg'
import sc2556 from '../images/portfolio/sc2556.jpg'
import sc2557 from '../images/portfolio/sc2557.jpg'
import medal from '../images/portfolio/medal.jpg'
import royal from '../images/portfolio/royal.jpg'
import royalAward from '../images/portfolio/royal-award.jpg'
import cs2555 from '../images/portfolio/cs2555.jpg'
import cs2556 from '../images/portfolio/cs2556.jpg'
import cs2557 from '../images/portfolio/cs2557.jpg'
import mos1 from '../images/portfolio/mos1.jpg'
import mos2 from '../images/portfolio/mos2.jpg'
import siammos1 from '../images/portfolio/siammos1.jpg'
import siammos2 from '../images/portfolio/siammos2.jpg'
import mrwiggle from '../images/portfolio/mrwiggle.jpg'
import ksinging from '../images/portfolio/ksinging.jpg'
import kec from '../images/portfolio/kec.jpg'
import masterclass from '../images/portfolio/masterclass.jpg'
import kpopcamp from '../images/portfolio/kpopcamp.jpg'
import gmm from '../images/portfolio/gmm.jpg'
import acm from '../images/portfolio/acm.jpg'
import devcamp from '../images/portfolio/devcamp.jpg'
import algocamp from '../images/portfolio/algocamp.jpg'
import yearend_2019 from '../images/portfolio/yearend_2019.jpg'

export default function Portfolio() {
    return <>
        <h2>AWARDS</h2>
        <Timeline>
            {/* <Timeline.Item color='green'><b>2023</b> KAIST CoE SoC "University Visit Program" - Selected Participant
                <a href='https://herald.kaist.ac.kr/news/articleView.html?idxno=20817' target='blank'>
                    <Tag color='green' style={{ marginLeft: 10 }}><GlobalOutlined /> visit</Tag>
                </a>
            </Timeline.Item>             */}
            <Timeline.Item color='green'><b>2022</b> “Dokdo Love” Korean Speaking Contest - 1st Place Winner (Team: K-GOOSE)
                <a href='https://herald.kaist.ac.kr/news/articleView.html?idxno=20817' target='blank'>
                    <Tag color='green' style={{ marginLeft: 10 }}><GlobalOutlined /> visit</Tag>
                </a>
            </Timeline.Item>
            <Timeline.Item color='green'><b>2020~2024</b> KAIST Scholarship for Graduate Students (Doctoral Program)</Timeline.Item>
            <Timeline.Item color='green'><b>2019</b> KAIST ISSS Year-End Party Talent Show - 3rd Prize
                <Popover content={<img width='280' src={yearend_2019} />} title={false}>
                    <Tag color='green' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='green'><b>2018~2020</b> KAIST Scholarship for Graduate Students (Master Program)</Timeline.Item>
            <Timeline.Item color='green'><b>2017</b> Hip Hop International Thailand - 1st Place Winner in Megacrew Division (Team: D Maniac Megacrew)
                <Popover content={
                    <div>
                        <img width='280' src={hhi3} alt="Hip Hop International Thailand 2017" />
                        <img width='280' src={hhi1} alt="Hip Hop International Thailand 2017" />
                        <img width='280' src={hhi2} alt="Hip Hop International Thailand 2017" />
                    </div>
                } title={false}>
                    <Tag color='green' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='green'><b>2016</b> LINE Finance Night Dance Competition by LINE FINANCE - 1st Place Winner (Team: D Maniqueen)
                <Popover content={<img width='280' src={line} />} title={false}>
                    <Tag color='green' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='green'><b>2014~2016</b> Faculty of Science Awards for Outstanding Academic Achievement Student
                <Popover content={
                    <div>
                        <img width='280' src={sc2555} alt='SCAWARD Certificate' />
                        <img width='280' src={sc2556} alt='SCAWARD Certificate' />
                        <img width='280' src={sc2557} alt='SCAWARD Certificate' />
                    </div>} title={false}>
                    <Tag color='green' style={{ marginLeft: 10 }}><FileSearchOutlined /> view (original)</Tag>
                </Popover>
                <Popover content={<img width='280' src='https://firebasestorage.googleapis.com/v0/b/itouchz-f1de4.appspot.com/o/scaward-translation.png?alt=media&token=24574c4c-700f-4a0a-b99a-85be70ebbbe5' />} title={false}>
                    <Tag color='green' style={{ marginLeft: 10 }}><FileSearchOutlined /> view (translation)</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='green'><b>2013~2015</b> Medal of Excellent Academic Achievement
                <Popover content={<img width='280' src={medal} />} title={false}>
                    <Tag color='green' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='green'><b>2013~2015</b> 5A Scholarship from the Department of Computer Science
                <Popover content={
                    <div>
                        <img width='280' src={cs2555} alt='CS 5A Certificate' />
                        <img width='280' src={cs2556} alt='CS 5A Certificate' />
                        <img width='280' src={cs2557} alt='CS 5A Certificate' />
                    </div>} title={false}>
                    <Tag color='green' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='green'><b>2012~2014</b> Tuition fee Exemption from Kasetsart University</Timeline.Item>
            <Timeline.Item color='green'><b>2012</b> King's Royal Awards from Ministry of Education - Qualified Grantee of Big Vocational College
                <Popover content={
                    <div>
                        <img width='280' src={royal} alt='Royal Awards Certificate' />
                        <img width='280' src={royalAward} alt='Royal Awards Certificate' />
                    </div>} title={false}>
                    <Tag color='green' style={{ marginLeft: 10 }}><FileSearchOutlined /> view (original)</Tag>
                </Popover>
                <Popover content={<img width='280' src='https://firebasestorage.googleapis.com/v0/b/itouchz-f1de4.appspot.com/o/royal-translation.png?alt=media&token=73d2f219-3310-4b1a-9454-3af40834945d' />} title={false}>
                    <Tag color='green' style={{ marginLeft: 10 }}><FileSearchOutlined /> view (translation)</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='green'><b>2011</b> MOS Olympics Competition Thailand by ARiT - 3rd Runner Up
                <Popover content={
                    <div>
                        <img width='280' src={mos1} alt='MOS Olympics Thailand' />
                        <img width='280' src={mos2} alt='MOS Olympics Thailand' />
                    </div>} title={false}>
                    <Tag color='green' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='green'><b>2011</b> SIAM MOS Competition by ARiT - Winner H.R.H Princess Soamsawali Trophy
                <Popover content={
                    <div>
                        <img width='280' src={siammos1} alt='Siam Mos Thailand' />
                        <img width='280' src={siammos2} alt='Siam Mos Thailand' />
                    </div>} title={false}>
                    <Tag color='green' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
        </Timeline>
        <h2>CERTIFICATES</h2>
        <Timeline>
            <Timeline.Item color='blue'><b>2018</b> Mobile Sites Certification
                <Popover content={<img width='280' src='https://firebasestorage.googleapis.com/v0/b/itouchz-f1de4.appspot.com/o/ads.png?alt=media&token=d7421417-7be1-4322-8152-40fcfb073bd2' />} title={false}>
                    <Tag color='blue' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='blue'><b>2018</b> Certificate of Completion, Modern React with Redux
                <Popover content={<img width='280' src='https://firebasestorage.googleapis.com/v0/b/itouchz-f1de4.appspot.com/o/Screen%20Shot%202018-04-25%20at%2003.06.05.png?alt=media&token=8ff73f4f-392a-43e4-8319-cbf60765de84' />} title={false}>
                    <Tag color='blue' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='blue'><b>2017</b> Certificate of Completion, React Js and Redux Mastering Web Apps
                <Popover content={<img width='280' src='https://firebasestorage.googleapis.com/v0/b/itouchz-f1de4.appspot.com/o/ude.png?alt=media&token=b2c1b713-b5f0-41ab-ba5c-e31224c524cd' />} title={false}>
                    <Tag color='blue' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='blue'><b>2017</b> Certificate of Training, Mr.Wiggles Hip Hop Camp
                <Popover content={<img width='280' src={mrwiggle} />} title={false}>
                    <Tag color='blue' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='blue'><b>2016</b> Test of Practical Competency in ICT (TOPCIT): Level 2
                <Popover content={<img width='280' src='https://firebasestorage.googleapis.com/v0/b/itouchz-f1de4.appspot.com/o/topcit.png?alt=media&token=81b4c3f2-3c01-48a5-a026-de989235ec69' />} title={false}>
                    <Tag color='blue' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='blue'><b>2014</b> Certificate of Achievement, K-Singing Class at Korean Cultural Center
                <Popover content={<img width='280' src={ksinging} />} title={false}>
                    <Tag color='blue' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='blue'><b>2015</b> Certificate of Completion, 제1기 한국유학대비 한국어과정 from Korean Education Center
                <Popover content={<img width='280' src={kec} />} title={false}>
                    <Tag color='blue' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='blue'><b>2014</b> Certificate of Completion, the 5th Master Class from Move With Passion
                <Popover content={<img width='280' src={masterclass} />} title={false}>
                    <Tag color='blue' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='blue'><b>2014</b> Certificate of Participation, Thailand K-POP Camp for Young Talents
                <Popover content={<img width='280' src={kpopcamp} />} title={false}>
                    <Tag color='blue' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='blue'><b>2013</b> Certificate of Honor, Super Star Summer Camp by Monkey Town Academy at GMM Grammy
                <Popover content={<img width='280' src={gmm} />} title={false}>
                    <Tag color='blue' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='blue'><b>2013</b> Certificate of Participation, ACM-ICPC Thailand Central Group A Programming Contest
                <Popover content={<img width='280' src={acm} />} title={false}>
                    <Tag color='blue' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='blue'><b>2013</b> Certificate of Training, The 1st Software Developing Skills Training Camp from Department of Computer Science
                <Popover content={<img width='280' src={devcamp} />} title={false}>
                    <Tag color='blue' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
            <Timeline.Item color='blue'><b>2012</b> Certificate of Training, The 1st Programming Skills for Problem-solving Training Camp from Department of Computer Science
                <Popover content={<img width='280' src={algocamp} />} title={false}>
                    <Tag color='blue' style={{ marginLeft: 10 }}><FileSearchOutlined /> view</Tag>
                </Popover>
            </Timeline.Item>
        </Timeline>
        <h2>PROGRAMMING PROJECTS</h2>
        <Timeline>
            <Timeline.Item color='purple'>Korean Square Web Application (Personal Project using React.js) <a href='https://www.korean-square.in.th' target='blank'><Tag color='purple' style={{ marginLeft: 10 }}><GlobalOutlined /> visit</Tag></a></Timeline.Item>
            <Timeline.Item color='purple'>D Maniac Studio Mobile Application (Freelance Work using React Native) <a href='https://itunes.apple.com/us/app/d-maniac-studio/id1342560544?mt=8' target='blank'><Tag color='purple' style={{ marginLeft: 10 }}><AppleOutlined /> iOS</Tag></a> <a href='https://play.google.com/store/apps/details?id=com.dmaniac.studio&hl=en' target='blank'><Tag color='purple' style={{ marginLeft: 10 }}><AndroidOutlined /> Android</Tag></a></Timeline.Item>
            <Timeline.Item color='purple'>D Maniac Studio Web Application (Freelance Work using React.js) <a href='https://www.dmaniacstudio.com' target='blank'><Tag color='purple' style={{ marginLeft: 10 }}><GlobalOutlined /> visit</Tag></a></Timeline.Item>
            <Timeline.Item color='purple'>Sneakavilla Online Store (Freelance Work using Wordpress) <a href='https://www.sneakavilla.net' target='blank'><Tag color='purple' style={{ marginLeft: 10 }}><GlobalOutlined /> visit</Tag></a></Timeline.Item>
            <Timeline.Item color='purple'>Kyouei Co., Ltd. Website (Freelance Work using Wordpress) <a href='http://www.kyouei.co.th' target='blank'><Tag color='purple' style={{ marginLeft: 10 }}><GlobalOutlined /> visit</Tag></a></Timeline.Item>
            <Timeline.Item color='purple'>Sriracha Tugboat Co., Ltd. Website (Freelance Work using Wordpress) <a href='http://www.srirachatugboat.com' target='blank'><Tag color='purple' style={{ marginLeft: 10 }}><GlobalOutlined /> visit</Tag></a></Timeline.Item>
            <Timeline.Item color='purple'>Web Application UX/UI Design (Human-Computer Interaction Assignment and Project using AngularJs)</Timeline.Item>
            <Timeline.Item color='purple'>Robotz Language and Compiler (Formal Language & Automata Theory Project using Java)</Timeline.Item>
            <Timeline.Item color='purple'>Hook Flash Card E-Learning Web Application (Web Technology and Web Service Project#2 using CakePHP)</Timeline.Item>
            <Timeline.Item color='purple'>Workpoint Web-based Resource Management (Web Technology and Web Service Project#1 using PHP)</Timeline.Item>
            <Timeline.Item color='purple'>Floral Bloom (ERP Project using SAP B1)</Timeline.Item>
            <Timeline.Item color='purple'>Flower Bloom Online Store (SA Project on IBM Bluemix using Ruby on Rails)</Timeline.Item>
            <Timeline.Item color='purple'>Adventure in Wonderland (Software Engineering Game Project using Java)</Timeline.Item>
            <Timeline.Item color='purple'>Hangman Game (Network Application Project using Python with Tk GUI)</Timeline.Item>
            <Timeline.Item color='purple'>Index Sequential Search (Data Structure Project using Adobe Flash Animation) </Timeline.Item>
            <Timeline.Item color='purple'>Fan Store (Software Construction Project using Java) </Timeline.Item>
            <Timeline.Item color='purple'>Electricity Cost Prediction Program (DevCamp#1 Windows 8 Application Project using C#)</Timeline.Item>
            <Timeline.Item color='purple'>Hangman CLI Game (AlgoCamp#1 using Python)</Timeline.Item>
            <Timeline.Item color='purple'>Polynomial Calculation (Computer Programming Project using Python)</Timeline.Item>
            <Timeline.Item color='purple'>Store Project (Computer Programming Project using Python)</Timeline.Item>
        </Timeline>

        <h2>PERFORMING EXPERIENCES</h2>
        <Timeline>
            <Timeline.Item color='#e91e63'>D Maniac Megacrew - Hip Hop International Thailand 2017 (Winner) <a href='https://www.youtube.com/watch?v=NB81vzHH2RM' target='blank'><Tag color='pink' style={{ marginLeft: 10 }}><YoutubeOutlined /> prelims</Tag></a> <a href='https://www.youtube.com/watch?v=_7PrLMitjF8' target='blank'><Tag color='pink' style={{ marginLeft: 10 }}><YoutubeOutlined /> finals</Tag></a></Timeline.Item>
            <Timeline.Item color='#e91e63'>D Maniqueen - Hip Hop International Thailand 2017 (Ranked 12th) <a href='https://www.youtube.com/watch?v=uTRiWmHClDI' target='blank'><Tag color='pink' style={{ marginLeft: 10 }}><YoutubeOutlined /> prelims</Tag></a></Timeline.Item>
            <Timeline.Item color='#e91e63'>D Maniqueen - LINE FINANCE NIGHT DANCE COMPETITION 2016 (Winner)</Timeline.Item>
            <Timeline.Item color='#e91e63'>D Maniqueen - Hip Hop International Thailand 2016 (Ranked 6th)</Timeline.Item>
            <Timeline.Item color='#e91e63'>D Maniqueen - Seacon Street Int'l Challenge 2015 (Ranked 6th)</Timeline.Item>
            <Timeline.Item color='#e91e63'>D Maniqueen - To Be Number One Variety Showcase (NBT Channel)</Timeline.Item>
            <Timeline.Item color='#e91e63'>TomYumKoong - Hip Hop International Thailand 2015 (Ranked 4th) <a href='https://www.youtube.com/watch?v=b8F_xB99jss' target='blank'><Tag color='pink' style={{ marginLeft: 10 }}><YoutubeOutlined /> finals</Tag></a></Timeline.Item>
            <Timeline.Item color='#e91e63'>KU Dance Club - Kaset Fair Annual Festival 2016~2018</Timeline.Item>
            <Timeline.Item color='#e91e63'>KU Dance Club - Kasetsart University Orientation Day in Academic Year 2016</Timeline.Item>
            <Timeline.Item color='#e91e63'>KU Dance Club - KU Firstdate 2015~2016</Timeline.Item>
            <Timeline.Item color='#e91e63'>KU Dance Club - Freshy Night 2015~2016</Timeline.Item>
            <Timeline.Item color='#e91e63'>KU Dance Club - KDC Training and Workshop (Dance Instructor)</Timeline.Item>
            <Timeline.Item color='#e91e63'>KU Dance Club - Open Activity World Event 2014~2016</Timeline.Item>
            <Timeline.Item color='#e91e63'>KU Dance Club - Royal Project Foundation Annual Event 2015~2016 at Central World</Timeline.Item>
        </Timeline>
    </>
}